<template>
  <ul class="left-menu">
    <li>
      <a
        href="#"
        class="js-sidebar-open"
        :class="{ active : openMenu }"
        @click="setOpen"
      >
        <app-icon
          name="olympus-menu-icon"
          color="dark-gray"
          size="normal"
        />
      </a>
    </li>

    <li>
      <router-link to="/courses">
        <app-icon
          name="olymp-newsfeed-icon"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
      </router-link>
    </li>
  </ul>
</template>

<script>
// eslint-disable-next-line
// import Ps from 'perfect-scrollbar';
// eslint-disable-next-line
// import '../../../css/perfect-scrollbar.css';
import AppIcon from '../AppIcon'

export default {
  name: 'SidebarMental',
  components: {AppIcon},
  props: {
    // openMenuVar: {
    //   type: Boolean,
    //   default: false
    // }
  },
  // computed: {
  //   openMenu() {
  //     return this.openMenuVar;
  //   },
  // },
  data () {
    return {
      openMenu: false,
    }
  },
  watch: {
    // openMenuVar() {
    //   // this.openMenu = this.openMenuVar;
    //   console.log(this.openMenuVar);
    // },
  },
  methods: {
    getLink (item) {
      return `/${this.ppa}/${item}`
    },
    getLinkArticle() {
      return ['personal', 'mental'].includes(this.ppa)
    },
    setOpen() {
      this.openMenu = !this.openMenu
      this.$emit('openmenu', true);

    }
  },
}
</script>
